import { Moon, Sun } from 'lucide-react';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
    >
      <div className="toggle-track">
        <div className={`toggle-thumb ${theme === 'dark' ? 'dark' : 'light'}`}>
          {theme === 'dark' ? <Moon className="toggle-icon" /> : <Sun className="toggle-icon" />}
        </div>
      </div>
    </button>
  );
};
